import * as R from "ramda";
const STRUCTURE_ATTRIBUTE_LIST_PATH = [
  "data",
  "dataStructures",
  0,
  "dataStructureComponents",
  "attributeList"
];
const STRUCTURE_ATTRIBUTES_PATH = R.append(
  "attributes",
  STRUCTURE_ATTRIBUTE_LIST_PATH
);
export {
  STRUCTURE_ATTRIBUTES_PATH,
  STRUCTURE_ATTRIBUTE_LIST_PATH
};
